// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"169":"070aec47","329":"bac486ca","346":"74ace5b8","393":"4bd9cb77","443":"e23e6226","730":"ec008956","901":"37b4bc57"}[chunkId] + ".js";
};